export const ROUTES = {
  home: { title: 'Home', href: '/home', logo: 'homeLogo' },
  plan: {
    title: 'Plan',
    href: '/plan',
    children: {
      loadEntry: {
        title: 'Load entry',
        href: '/plan/load-entry',
        logo: 'loadEntry',
        subTitle: 'Create and plan loads',
      },
      timeline: {
        title: 'Timeline',
        logo: 'planningBoard',
        href: '/plan/timeline',
        subTitle: 'Plan resources over time',
      },
    },
  },

  monitor: {
    title: 'Monitor',
    href: '/monitor',
    children: {
      driverVisibility: {
        title: 'Driver visibility',
        href: '/monitor/driver-visibility',
        logo: 'driverVisibility',
        subTitle: 'Track drivers on map',
      },
      activeLoads: {
        title: 'Active loads',
        href: '/monitor/active-loads',
        logo: 'activeLoads',
        subTitle: 'View loads in progress',
      },
      activeExceptions: {
        title: 'Active Exceptions',
        href: '/monitor/active-exceptions',
        logo: 'activeExceptions',
        subTitle: 'Manage exceptions',
      },
    },
  },

  review: {
    title: 'Review',
    href: '/review',
    children: {
      signoff: {
        title: 'Sign-off',
        href: '/review/sign-off',
        logo: 'signOff',
        subTitle: 'Review completed loads',
      },
      efficiencyManagement: {
        title: 'Efficiency Management',
        href: '/review/efficiency-management',
        logo: 'efficiencyManagement',
        subTitle: 'Improve driver efficiency',
      },
    },
  },

  allLoads: { title: 'All loads', href: '/all-loads', logo: 'loadBoard' },
  data: {
    title: 'Data',
    href: '/datamanagement',
    children: {
      facilities: {
        title: 'Facilities',
        logo: 'dataManagement',
        href: '/datamanagement?tab=facilities',
      },
      equipment: {
        title: 'Equipment',
        logo: 'dataManagement',
        href: '/datamanagement?tab=equipment',
      },
    },
  },
}
